import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Header, HeaderProps } from './header';
import { Sidebar, SidebarNavigationItem } from './sidebar';

import './layout.scss';
// import {ChatComponent} from "Components/shared";

import { getProfileID } from 'Helpers/session';

export interface LayoutProps {
  headerProps?: Omit<HeaderProps, 'hasSidebar' | 'onTogglerClick'>;
  headerChildren?: React.ReactNode;
  contentHeaderChildren?: React.ReactNode;
  hasSidebar?: boolean;
  isHorizontalScrollable?: boolean;
  navigation?: SidebarNavigationItem[];
}

export const Layout: React.FC<LayoutProps> = ({
  navigation,
  headerProps,
  headerChildren,
  contentHeaderChildren,
  hasSidebar = false,
  isHorizontalScrollable = false,
  children,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(false);
  const profileID = getProfileID();

  useEffect(() => {
    const contentBody = document.querySelector('#contentBody');
    contentBody!.scrollTop = contentBody!.scrollHeight - contentBody!.clientHeight;
  }, [])

  const handleToggleSidebar = (isCollapsed: boolean) => {
    setIsSidebarCollapsed(isCollapsed)
  }

  return (
    <div className={classNames('layout', {
      'layout--has-sidebar': hasSidebar,
      'layout--sidebar-collapsed': isSidebarCollapsed,
    })}>
      <Header
        hasSidebar={hasSidebar}
        onTogglerClick={() => setIsSidebarOpen(!isSidebarOpen)}
        {...headerProps}
      >
        {headerChildren}
      </Header>

      <main id="contentBody" className="layout-content">
        {hasSidebar &&
          <Sidebar
            navigation={navigation || []}
            isOpen={isSidebarOpen}
            onToggle={handleToggleSidebar}
          />
        }

        <div className="layout-content-inner">
          {contentHeaderChildren &&
            <div className="layout-content--header">
              {contentHeaderChildren}
            </div>
          }

          <div className={classNames('layout-content--body', {
            'layout-content--body--has-header': !!contentHeaderChildren,
            'layout-content--body--horizontal-scrollable': isHorizontalScrollable,
          })}>
            {children}
          </div>
        </div>
      </main>

    </div>
  )
}
